<template>
    <div>
        <h1>{{ $t('labels.edit_activities') }}</h1>

        <div class="row row-scrollable">
            <div class="col-sm-6">
                <h5 v-text="$t('labels.shown')"></h5>
                <draggable class="list-group list-group--draggable list-group--scrollable" tag="ul" v-model="visible" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                    <transition-group type="transition" :name="'flip-list'">
                        <li class="list-group-item" v-for="activity in visible" :key="activity.id">
                            <span class="js-handle">::</span>
                            {{ getName(activity) }}
                        </li>
                    </transition-group>
                </draggable>
            </div>

            <div class="col-sm-6">
                <h5 v-text="$t('labels.hidden')"></h5>
                <draggable class="list-group list-group--draggable list-group--scrollable" tag="ul" v-model="hidden" v-bind="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                    <transition-group :name="'flip-list'" type="transition">
                        <li class="list-group-item" v-for="activity in hidden" :key="activity.id">
                            <span class="js-handle">::</span>
                            {{ getName(activity) }}
                        </li>
                    </transition-group>
                </draggable>
            </div>
        </div>

        <div class="app-actions">
            <div class="col-sm-6">
                <button class="btn btn-secondary btn--xl" @click="reset">
                    <font-awesome-icon :icon="['fas', 'sync']" class="mr-2" /> {{ $t('labels.reset') }}
                </button>
            </div>

            <div class="col-sm-6 text-right">
                <button class="btn btn-primary btn--xl" @click="close">{{ $t('labels.close') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'

    export default {
        name: 'activities-page',

        components: {draggable},

        data () {
            return {
                visible: [],
                hidden: [],
                editable:true,
                isDragging: false,
                delayedDragging:false
            }
        },

        computed: {
            currentLocation () {
                return this.$store.getters.currentLocation
            },

            activityOrder () {
                return this.$store.getters.activityOrder
            },

            activities () {
                return this.$store.getters.activities
            },

            dragOptions () {
                return  {
                    handle: ".js-handle",
                    animation: 150,
                    group: 'activity',
                    disabled: !this.editable,
                    ghostClass: 'ghost'
                };
            },

            listVisible(){
                return this.visible.map(activity => {
                    return activity.id
                }).join('|');
            },

            listHidden(){
                return this.hidden.map(activity => {
                    return activity.id
                }).join('|');
            },
        },

        watch: {
            isDragging (newValue) {
                if (newValue){
                    this.delayedDragging = true
                    return
                }
                this.$nextTick( () =>{
                    this.delayedDragging = false
                })
            },

            listVisible (order) {
                this.$store.dispatch('setActivityOrder', order);
            }
        },

		methods: {
			getImage (activity) {
				if (activity.image_path !== null && activity.image_path !== undefined) {
					const img = new Image()
					img.onload = function () {
						const container = document.getElementById(activity.id)

						if(container) {
							container.src = activity.image_path;
						}
					}
					img.src = activity.image_path
				}
			},

			getName (activity) {
				const lang = document.documentElement.lang

				if (activity.translations && activity.translations[lang]) {
					return activity.translations[lang]
				}

				return activity.name
			},

			orderList () {
				this.list = this.list.sort((one,two) =>{return one.order-two.order; })
			},

			onMove ({relatedContext, draggedContext}) {
				const relatedElement = relatedContext.element;
				const draggedElement = draggedContext.element;
				return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
			},

			reset () {
				this.$store.commit('clearActivityOrder');
				this.$store.commit('setChecked');
			},

			close () {
                let navbar = this.$parent.$children.find(item => item.$options.name === 'navbar');

                if (!navbar) return this.$router.go(-1);

                return window.setTimeout(() => this.$router.go(-1), 300);
			}
		},

		mounted () {
			window.events.$emit('disableNumpad');

			if(
                (this.$store.getters.currentEmployee === null || this.$store.getters.currentEmployee === undefined) &&
                this.currentDevice &&
                this.currentDevice.register_activities
            ) {
				this.$router.push({name: 'pin'});
			}

			let main = document.querySelector('.app-main');
			let sidebar = document.querySelector('.app-sidebar');

			main.classList.add('app-main--fullscreen');
			sidebar.style.display = 'none';

			window.events.$emit('setFullscreen', true);

			const ordered = this.activityOrder
                ? this.activityOrder.split('|')
                : (this.currentLocation && this.currentLocation.activity_order ? this.currentLocation.activity_order : []);

			this.visible = this.activities.filter(activity => {
				return ordered.indexOf(activity.id.toString()) > -1
			})
			.map(activity => {
				activity.order = ordered.indexOf(activity.id.toString());
				return activity;
			})
			.sort((a, b) => {
				if (a.order > b.order) return 1;
				if (a.order < b.order) return -1;
				return 0;
			});

			this.hidden = this.activities.filter(activity => ordered.indexOf(activity.id.toString()) === -1);
		},

		beforeDestroy () {
			window.events.$emit('setFullscreen', false);

			let main = document.querySelector('.app-main');
			let sidebar = document.querySelector('.app-sidebar');

			main.classList.remove('app-main--fullscreen');
			sidebar.style.display = 'flex';
		}
    }
</script>

<style scoped>

    .actions--fixed {
        height: calc(100% - 40px);
    }

    .actions--fixed > div {
        overflow: scroll;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: .5;
        background: #C8EBFB;
    }
    .list-group {
        min-height: 20px;
    }
    .list-group--draggable {
        height: 100%;
        background: rgba(255,255,255,.75);
    }
    .list-group--draggable > span {
        height: 100%;
    }
    .list-group-item {
        padding: 0.75rem 1.25rem .75rem 0;
        cursor: move;
    }
    .list-group-item i{
        cursor: pointer;
    }

    .js-handle {
        cursor: move;
        cursor: -webkit-grabbing;
        padding: .75rem 1.25rem;
    }
</style>
